const adjustRate = rate => +(rate * 100).toFixed(2);

const calculateFee = (rate, value) => {
  return (adjustRate(rate) * value) / 100;
};

export { adjustRate, calculateFee };
